import React, { useRef } from 'react'
import { Container, Row, Col } from 'reactstrap';
import { Formik, Form } from "formik";
import MultiSelect from "../../forms/Select2Multi";


const FilterLocationItems = ({ action, data, toggle, match, filterCity, filterJob, cityOptions = [], jobOptions = [] }) => {
    const formikRef = useRef();

    const initial = data ? {
        // id: data?.id,
        city: filterCity ? filterCity : "",
        job: filterJob ? filterJob : ""
    } : {
        city: filterCity ? filterCity : "",
        job: filterJob ? filterJob : ""
    }

    const initialTouched = {
        city: true,
    }

    

    return (
        <>
            <Formik
                innerRef={formikRef}
                initialValues={initial}
                enableReinitialize
                initialTouched={initialTouched}
                // validationSchema={validation}
                onSubmit={(values, { setStatus, setSubmitting }) => {
                    setStatus();
                    let job = ''
                    if(values.city === 'all'){
                        values.city = ''
                    }
                    if(values.job !== 'all') {
                        job = values.job
                    }
                    action(values.city, job );
                }}
            >
                {(props) => (
                    <Form>
                        <Container>
                            <MultiSelect
                                name="city"
                                options={cityOptions}
                                title="Kota Asal"
                                errors={props?.errors}
                                touched={props?.touched}
                                value={props?.values.city}
                                onChange={(name, value) => {
                                    props?.setFieldValue("city", String(value));
                                }}
                                onBlur={props?.setFieldTouched}
                                
                            />
                            {/* <Select2
                                name="city"
                                options={dataCity}
                                errors={props?.errors}
                                touched={props?.touched}
                                value={props?.values?.city}
                                onChange={(name, value) => {
                                    props?.setFieldValue("city", value);
                                }}
                                onBlur={props?.setFieldTouched}
                                
                            /> */}

                            <MultiSelect
                                name="job"
                                title="Pekerjaan"
                                options={jobOptions}
                                errors={props?.errors}
                                touched={props?.touched}
                                value={props?.values.job}
                                onChange={(name, value, e) => {
                                    props?.setFieldValue("job", String(value));
                                }}
                                onBlur={props?.setFieldTouched}
                                
                            />
                            
                            <Row style={{marginTop: 20, justifyContent:"end"}}>
                                <Col sm={7}>
                                    <button type="button" className="button-batal" onClick={toggle}>
                                        Batal
                                    </button>
                                    <button type="submit" className="button-simpan">
                                        Terapkan
                                    </button>
                                </Col>
                            </Row>
                        </Container>
                    </Form>
                )}
            </Formik>
        </>
    )
}


export default FilterLocationItems;
